import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import CustomModal from '../../../../components/modal/CustomModal';
import { ReactComponent as EnvelopeIcon } from '../../../../assets/icons/project-icons/EnvelopeIcon.svg';
import CustomButton from '../../../../components/button/CustomButton';
import useCreate from '../../../../utils/hooks/crud-hooks/useCreate';

export interface LoginModalProps {
  open: boolean;
  email: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setOpenSuccessModal: Dispatch<SetStateAction<boolean>>;
}

export const LoginModal = ({ open, email, setIsOpen, setOpenSuccessModal }: LoginModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mutate: resendEmail } = useCreate<Record<string, unknown>, Record<string, unknown>>({
    resource: '/auth/resend-verification',
  });

  const resendVerification = () => {
    resendEmail(
      { email },
      {
        onSuccess: () => {
          setOpenSuccessModal(true);
          setIsOpen(false);
        },
      },
    );
  };
  return (
    <CustomModal open={open} sx={{ width: { xs: '85%', lg: '45%' } }}>
      <Stack spacing={3}>
        <Stack spacing={2} direction="row" alignItems="center">
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              bgcolor: '#E5E8FF',
              width: 'fit-content',
              height: 'fit-content',
              borderRadius: '6px',
              p: 1.5,
            }}
          >
            <EnvelopeIcon />
          </Stack>
          <Typography variant="heading3" color="primaryDark.600">
            {t('register.modals.unverifiedEmail.title')}
          </Typography>
        </Stack>
        <Divider />
        <Typography color="primaryDark.500">
          {t('register.modals.unverifiedEmail.text1')}

          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={resendVerification}
          >
            {t('register.modals.unverifiedEmail.text2')}
          </span>
        </Typography>
        <Typography color="primaryDark.500">
          {t('register.modals.unverifiedEmail.text3')}
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => navigate('/contact-us')}
          >
            {t('register.modals.unverifiedEmail.text4')}
          </span>
        </Typography>
        <Divider />
        <Stack sx={{ justifyContent: 'end' }} spacing={2} direction="row">
          <CustomButton variant="secondary" onClick={() => setIsOpen(false)}>
            {t('common.cancel')}
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};
